<template>
  <div class="box">
    <swiper :options="swiperOption" v-if="clientWidth > 768" ref="mySwiper" :auto-play="true"
      class="modulelist6_box download_box">
      <div v-if="clientWidth > 768" class="swiper-button-prev swiper-button-prev-dl-pc swiper-button2"
        slot="button-prev"></div>
      <div v-if="clientWidth > 768" class="swiper-button-next swiper-button-next-dl-pc swiper-button2"
        slot="button-next"></div>
      <swiper-slide v-for="(item, index) in list_pc" :key="index" class="modulelist6">
        <div class="modulelist6_children" v-for="(val, index) in item.children" :key="index" 
          :data-item="JSON.stringify(val)" style="cursor: pointer;">
          <div class="modulelist6_content">
            <div class="modulelist6_left">
              <span>{{ val.title }}</span>
              <div class="line6"></div>
              <span v-html="val.content" :class="tab ? 'modulelist6_left_span' : ''" :title="val.content"></span>
            </div>
            <div class="modulelist6_right">
              <div :data-item="JSON.stringify(val)" v-if="tab">
                <span>获取客户案例</span>
                <img :src="Res_Url+'/index/icon_download.png'" alt="" />
              </div>
              <div :data-item="JSON.stringify(val)" v-else>
                <span>获取行业解决方案</span>
                <img :src="Res_Url+'/index/icon_download.png'" alt="" />
              </div>
            </div>
          </div>
          <div class="modulelist6_img">
            <img :src="Res_Url+'/downloadCenter/' + val.img" alt="" />
          </div>
        </div>
      </swiper-slide>
      <!-- 指示点 -->
      <div class="swiper-pagination fx2" slot="pagination"></div>
    </swiper>
    <swiper :options="swiperOption_m" v-else ref="mySwiper" :auto-play="true" class="modulelist6_box download_box">
      <div class="swiper-button-prev swiper-button-prev-dl-m swiper-button2"
        slot="button-prev"></div>
      <div class="swiper-button-next swiper-button-next-dl-m swiper-button2"
        slot="button-next"></div>
      <swiper-slide v-for="(item, index) in list_m" :key="index" class="modulelist6"
        :data-item="JSON.stringify(item.children[0])" style="cursor: pointer;">

        <div class="modulelist6_children" v-if="!tab">
          <div class="modulelist6_img">
            <img :src="Res_Url+'/downloadCenter/' + item.children[0].img_m" alt="" />
          </div>
          <div class="modulelist6_content">
            <div class="modulelist6_left">
              <span>{{ item.children[0].title }}</span>
              <div class="line6"></div>
              <span v-html="item.children[0].content.replaceAll('\n', '<br>')"
                :title="item.children[0].content.replaceAll('\n', '<br>')"></span>
            </div>
            <div class="modulelist6_right">
              <div :data-item="JSON.stringify(item.children[0])">
                <span>获取行业解决方案</span>
                <img :src="Res_Url+'/index/icon_download.png'" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-else class="modulelist6_children_box">
          <div class="modulelist6_children" v-for="(val, vindex) in item.children" :key="vindex"
            :data-item="JSON.stringify(val)" style="cursor: pointer;">

            <div class="modulelist6_img">
              <img :src="Res_Url+'/downloadCenter/' + val.img_m" alt="" />
            </div>
            <div class="modulelist6_content">
              <div class="modulelist6_left">
                <span>{{ val.title }}</span>
                <div class="line6"></div>
                <span v-html="val.content.replaceAll('\n', '<br>')"
                  :title="item.children[0].content.replaceAll('\n', '<br>')"
                  :class="tab ? 'modulelist6_left_span' : ''"></span>
              </div>
              <div class="modulelist6_right">
                <div :data-item="JSON.stringify(val)">
                  <span>获取客户案例</span>
                  <img :src="Res_Url+'/index/icon_download.png'" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="intronumber">
      <div class="left"></div>
      <span v-if="clientWidth > 768">{{ currentIndex }}/{{ list_pc.length }}</span>
      <span v-if="clientWidth <= 768">{{ currentIndex_m }}/{{ list_m.length }}</span>
      <div class="right"></div>
    </div>
    <Rdialog :articleName="articleName" :isRegister="isRegister" :isEmail="isEmail" :isIntegral="isIntegral"
      @handleClose="handleClose" @handleEmail="handleEmail" :integralText="integralText"></Rdialog>
  </div>
</template>

<script>
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.min.css";
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation, EffectFade]);

import Rdialog from "@/components/rdialog/index.vue";
import { AddPoints } from "../../api/index.js";
import { Res_Url } from "@/utils/ApiToken.js";

export default {
  props: {
    data: {
      type: Object,
      value: {},
    },
    tab: {
      type: Boolean,
      value: false,
    },
  },
  components: {
    Swiper,
    SwiperSlide,
    Rdialog,
  },
  mounted() {
    this.currentData = this.data.industry;
    // 在mounted后绑定全局点击事件
    this.$nextTick(() => {
      this.bindGlobalClickEvents();
      // 确保显示第一张幻灯片
      this.$nextTick(() => {
        this.ensureFirstSlide();
      });
    });
  },
  beforeDestroy() {
    // 清理事件监听器
    document.removeEventListener('click', this.handleGlobalClick);
  },
  data() {
    const that = this;
    return {
      Res_Url:Res_Url,
      active: 1,
      // list_pc: [],
      currentData: [],
      isRegister: false,
      isEmail: false,
      currentIndex: 1,
      currentIndex_m: 1,
      swiperOption: {
         initialSlide: 1, // 从第一张开始播放
         slidesPerView: 1, // 一行显示3个
        // slidesPerGroup: 3,
        // freeMode: true,
        // slidesPerView: 'auto',
        speed: 1000, // 滑动速度
        effect: "flip",
        loop: true, // 启用循环
        slideToClickedSlide: true,
        loopedSlides: 1, // 只克隆1个幻灯片
        spaceBetween: 40,
        // autoplay: {
        //   delay: 4000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        // loopedSlides: 8,
        navigation: {
          nextEl: ".swiper-button-next-dl-pc",
          prevEl: ".swiper-button-prev-dl-pc",
        },
        on: {
          init: (swiper) => {
            // 确保初始化时显示第一张真实幻灯片
            that.currentIndex = 1;
          },
          slideChange: (swiper) => {
            that.currentIndex = swiper.realIndex + 1;
          },
        },
      },
             swiperOption_m: {
         initialSlide: 1, // 从第一张开始播放
         direction: "horizontal",
        autoplay: {
          delay: 500000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: true, // 启用循环
        slideToClickedSlide: true,
        loopedSlides: 1, // 只克隆1个幻灯片
        slidesPerView: 1, // 确保移动端显示1个幻灯片
        centeredSlides: false, // 修复：禁用居中显示，避免与循环冲突
        spaceBetween: 40,
        navigation: {
          nextEl: ".swiper-button-next-dl-m",
          prevEl: ".swiper-button-prev-dl-m",
        },
        on: {
          init: (swiper) => {
            // 确保初始化时显示第一张真实幻灯片
            that.currentIndex_m = 1;
          },
          slideChange: (swiper) => {
            that.currentIndex_m = swiper.realIndex + 1;
          },
        },
      },
      articleName: "",
      isIntegral: false,
      integralText: "",
    };
  },
  methods: {
    // 确保显示第一张幻灯片
    ensureFirstSlide() {
      if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
        // 强制跳转到第一张真实幻灯片
        this.$refs.mySwiper.swiper.slideTo(0, 0);
      }
    },
    
    // 绑定全局点击事件
    bindGlobalClickEvents() {
      document.addEventListener('click', this.handleGlobalClick);
    },
    
    // 处理全局点击事件
    handleGlobalClick(event) {
      // 检查点击的元素是否在swiper容器内
      const swiperContainer = document.querySelector('.download_box');
      if (!swiperContainer || !swiperContainer.contains(event.target)) {
        return;
      }
      
      // 查找最近的带有data-item属性的元素
      let target = event.target;
      let item = null;
      
      while (target && target !== swiperContainer) {
        if (target.dataset && target.dataset.item) {
          try {
            item = JSON.parse(target.dataset.item);
            break;
          } catch (e) {
            // 解析失败，继续查找
          }
        }
        target = target.parentElement;
      }
      
      // 如果找到了数据，执行下载
      if (item) {
        event.preventDefault();
        event.stopPropagation();
        this.handleDown(item);
      }
    },
    
    handleDown(item) {
      let obj;
      if (this.tab) {
        obj = { event: "trk", ec: "download", ea: "storyssolutions", el: "solutions" };
      } else {
        obj = { event: "trk", ec: "download", ea: "insightssolutions",  el: "solutions"};
      }
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      if (this.$store.state.islogin) {
        this.articleName = item.code;
        this.sendSuccess = false;
        this.isEmail = true;
      } else {
        this.isRegister = true;
      }
    },
    handleEmail(e) {
      AddPoints({
        visitType: this.active === 1 ? 23 : 13,
        track: this.$route.query.track ? this.$route.query.track : "",
        name: this.articleName,
        email: e,
      }).then((res) => {
        if (res.Status === 1) {
          this.isEmail = false;
          this.isIntegral = true;
          if (res.Data === "1") {
            this.integralText = res.Message;
          } else {
            this.integralText = "恭喜您，下载成功";
          }
        }
      });
    },
    handleClose() {
      this.isEmail = false;
      this.isRegister = false;
      this.isIntegral = false;
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    list_m() {
      let arr = [];
      if (this.tab && this.clientWidth < 768) {
        let i = Math.ceil(this.currentData.length / 2);
        for (let ind = 0; ind < i; ind++) {
          arr.push({
            children: [],
          });
        }

        let index = 0;
        this.currentData.map((sub, subIndex) => {
          arr[index].children.push(sub);
          if (arr[index].children.length >= 2) {
            index += 1;
          }
        });
      } else {
        let i = Math.ceil(this.currentData.length / 1);
        for (let ind = 0; ind < i; ind++) {
          arr.push({
            children: [],
          });
        }

        let index = 0;
        this.currentData.map((sub, subIndex) => {
          arr[index].children.push(sub);
          if (arr[index].children.length >= 1) {
            index += 1;
          }
        });
      }
      
      // 移动端按钮显示逻辑
      let eles;
      if (arr.length === 1 && arr) {
        eles = document.querySelectorAll(".swiper-button2");
        if (eles && eles.length) {
          for (const n of eles) {
            n.style.display = "none";
          }
        }
      } else if (arr.length > 1) {
        eles = document.querySelectorAll(".swiper-button2");
        if (eles && eles.length) {
          for (const n of eles) {
            n.style.display = "flex";
          }
        }
      }
      
      return arr;
    },
    list_pc() {
      let arr = [];
      if (this.tab && this.clientWidth > 768) {
        let i = Math.ceil(this.currentData.length / 6);
        for (let ind = 0; ind < i; ind++) {
          arr.push({
            children: [],
          });
        }

        let index = 0;
        this.currentData.map((sub, subIndex) => {
          arr[index].children.push(sub);
          if (arr[index].children.length >= 6) {
            index += 1;
          }
        });
        console.log(arr)
      } else {
        let i = Math.ceil(this.currentData.length / 4);
        for (let ind = 0; ind < i; ind++) {
          arr.push({
            children: [],
          });
        }

        let index = 0;
        this.currentData.map((sub, subIndex) => {
          arr[index].children.push(sub);
          if (arr[index].children.length >= 4) {
            index += 1;
          }
        });
      }

      let eles;
      if (arr.length === 1 && arr) {
        eles = document.querySelectorAll(".swiper-button2");
        if (eles && eles.length) {
          for (const n of eles) {
            n.style.display = "none";
          }
        }
      } else if (arr.length > 1) {
        eles = document.querySelectorAll(".swiper-button2");
        if (eles && eles.length) {
          for (const n of eles) {
            n.style.display = "flex";
          }
        }
      }
      return arr;
    },
  },
  watch: {
    tab() {
      document.querySelector(".download_box").style.opacity = 0;
      setTimeout(() => {
        document.querySelector(".download_box").style.opacity = 1;
        // 重置当前索引
        this.currentIndex = 1;
        this.currentIndex_m = 1;
        // 确保切换后显示第一张幻灯片
        this.$nextTick(() => {
          this.ensureFirstSlide();
        });
      }, 100);
      // this.list_pc = []
      // this.list_m = []
      document.querySelector(".download_box").classList.remove("lowBox");
      if (this.tab) {
        this.currentData = this.data.customer;
        if (this.clientWidth > 768) {
          document.querySelector(".download_box").classList.add("lowBox");
        }
        this.active = 2;
      } else {
        this.currentData = this.data.industry;
        this.active = 1;
      }
    },
    currentData() {
      // 数据变化时重置索引
      this.currentIndex = 1;
      this.currentIndex_m = 1;
      this.$nextTick(() => {
        this.ensureFirstSlide();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>